<template>
  <div class=''>123</div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  computed: {},
  watch: {},
  methods: {

  },
  mounted() {

  },
  components: {},
}
</script>

<style lang='scss' scoped></style>